// extracted by mini-css-extract-plugin
export default {"textHead":"backModal_textHead__PJFeQ","dialog-btnss":"backModal_dialog-btnss__acUsz"};